import React, { useEffect } from 'react'

import CTA from '@f/elements/CTA'
import Icon from '@f/elements/Icon'

const BottomBanner = props => {
  useEffect(() => {
    _wt({
      category: 'banner',
      action: 'display',
      values: [
        {
          type: 'name',
          value: props.wtLocation
        }
      ]
    })
  }, [])

  const closeBanner = () => {
    _wt({
      category: 'banner',
      action: 'hide',
      values: [
        {
          type: 'name',
          value: props.wtLocation
        }
      ]
    })

    props.closeBanner()
  }

  return (
    <div className='[ f-pos-rel f-shadow f-c-ba-pri f-c-fo-whi f-overflow ] FloatingBanner FloatingBanner-bottom-banner'>
      <div className='[ f-hidden:m f-hidden:l f-pos-rel ]'>
        <CTA
          type='icon'
          tag='button'
          className='[ f-pos-ab ] FloatingBanner-close'
          onClick={closeBanner}
          wtData={{
            'CTA-click': {
              location: `banner-${props.wtLocation}`
            }
          }}
          data-sel='btn-cls'>
          <Icon
            icon='close-16px'
            className='[ f-icon-020 f-c-st-whi ] FloatingBanner-close-icon'
          />
        </CTA>
      </div>
      <div className='[ f-wrap f-p-t-020 f-p-h-020 f-p-b-030 ] FloatingBanner-content'>
        <img
          src={props.illustration}
          className='[ f-hidden:s f-hidden:m ] BottomBanner-illustration'
        />
        <div className='FloatingBanner-content-message'>
          <div className='FloatingBanner-content-message-wrapper'>
            <div className='[ f-t-tminor f-p-r-020 ]'>{props.heading}</div>
            <div className='[ f-t-body f-p-v-010 ]'>{props.copy}</div>
          </div>
        </div>
        <CTA
          type='block-primary'
          tag='a'
          className='[ f-m-t-010 ] is-block:s'
          href={props.link}
          wtData={{
            'CTA-click': {
              location: `banner-${props.wtLocation}`
            }
          }}>
          {props.ctaCopy}
        </CTA>
        <CTA
          type='icon'
          tag='button'
          className='[ f-pos-ab f-fl-no ] FloatingBanner-close'
          onClick={closeBanner}
          wtData={{
            'CTA-click': {
              location: `banner-${props.wtLocation}`
            }
          }}
          data-sel='btn-cls'>
          <Icon
            icon='close-16px'
            className='[ f-hidden:s f-icon-030 f-c-st-whi ] FloatingBanner-close-icon'
          />
        </CTA>
      </div>
    </div>
  )
}

export default BottomBanner
